<template>
  <v-flex lg4>
      <v-card tile>
        <v-card-actions>
          <UploadBtn label="Choisir" :callBack="onFile"/>
        </v-card-actions>
        <v-card-media>
          <img :src="imageUrl" />
        </v-card-media>
      </v-card>
  </v-flex>
</template>

<script>
import UploadBtn from '@/components/form/UploadBtn'
export default {
  components: {
    UploadBtn,
  },
  data: () => ({
    imgBack: null,
  }),
  computed: {
    imageUrl: {
      get () {
        let fromSource = this.form.data.img_path !== undefined && this.form.data.img_path !== null
          ? `${process.env.VUE_APP_API_REST_URL}/${this.form.data.img_path}`
          : '/img/placeholder.png'
        return this.imgBack
          ? this.imgBack
          : fromSource
      },
      set (value) {
        this.imgBack = value
      },
    },
  },
  props: {
    updateField: Function,
    form: Object,
  },
  methods: {
    onFile (file) {
      let reader = new FileReader()
      reader.onload = e => {
        this.imageUrl = e.target.result
      }
      reader.readAsDataURL(file)
      this.updateField({key: 'photo', value: file})
    },
  },
}
</script>
<style scoped>
img {
  width: 100%;
  height: 100%;
}
</style>
